export default "__VITE_PUBLIC_ASSET__0fb1f70b__"